export function isPast(date: number | Date) {
    return new Date(date).getTime() < Date.now()
}